// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__HQMCk","modalFooterButton":"ModalNotes_modalFooterButton__1v7E4"};